import * as variables from '/src/assets/styles/variables.module.scss';

const interpolateWidth = (value, baseZoom = 20, minZoom = 0, maxZoom = 24) => {
  return [
    'interpolate',
    ['exponential', 2],
    ['zoom'],
    minZoom,
    ['*', value, ['^', 2, minZoom - baseZoom]],
    maxZoom,
    ['*', value, ['^', 2, maxZoom - baseZoom]]
  ];
};

const levelFilter = (filter) => [
  'let',
  'activeLevels',
  ['literal', ['qag_level_1', 'goma_level_1']],
  [
    'let',
    'isActiveLevel',
    [
      'any',
      ['!', ['has', 'level']],
      [
        'in',
        ['concat', ['get', 'building'], '_', ['get', 'level']],
        ['array', ['var', 'activeLevels']]
      ]
    ],
    filter
  ]
];

const closedVenueFilter = [
  'to-boolean',
  ['coalesce', ['get', 'isClosed'], false]
];

const openVenueFilter = ['!', closedVenueFilter];

const culturalCentreBounds = [
  [
    [153.01653742790222, -27.470439296677753],
    [153.01742792129517, -27.472390704839142],
    [153.0183720588684, -27.473828061432265],
    [153.01827549934387, -27.474170739706445],
    [153.01669836044312, -27.47508454322731],
    [153.01735281944275, -27.475969783161016],
    [153.01933765411377, -27.47521780560758],
    [153.01991701126096, -27.475465292457592],
    [153.0211615562439, -27.4747513865715],
    [153.0199384689331, -27.472885690683164],
    [153.01949858665466, -27.47166725999056],
    [153.01812529563904, -27.470467854119498],
    [153.01726698875427, -27.469830069490843],
    [153.01653742790222, -27.470439296677753]
  ]
];

export const culturalCentreBuildingLabels = {
  id: 'culturalCentreBuildingLabels',
  filter: [
    'in',
    ['get', 'name'],
    [
      'literal',
      [
        'State Library of Queensland',
        'Queensland Performing Arts Centre',
        'Queensland Museum',
        'The Edge'
      ]
    ]
  ],
  source: 'protomaps',
  'source-layer': 'buildings',
  type: 'symbol',
  layout: {
    'text-anchor': 'center',
    'text-field': ['get', 'name'],
    'text-font': ['Flama Book'],
    'text-letter-spacing': 0.02,
    'text-line-height': 1.1,
    'text-max-width': 8,
    'text-overlap': 'never',
    'text-size': 14,
    'text-rotation-alignment': 'map'
  },
  paint: {
    'text-color': '#797979',
    'text-halo-color': 'white',
    'text-halo-width': 2
  },
  minzoom: 16
};

export const amenities = {
  id: 'amenities',
  filter: [
    'all',
    [
      'in',
      ['get', 'amenity'],
      ['literal', ['parking', 'parking_entrance', 'bus_station']]
    ],
    [
      'within',
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Polygon',
          coordinates: culturalCentreBounds
        }
      }
    ]
  ],
  source: 'protomaps',
  'source-layer': 'pois',
  type: 'symbol',
  layout: {
    'icon-image': 'parking',
    'icon-size': ['interpolate', ['exponential', 2], ['zoom'], 16, 0.5, 22, 2],
    'icon-allow-overlap': true,
    'icon-overlap': 'always'
  },
  minzoom: 16
};

export const transitLabels = {
  id: 'transitLabels',
  filter: [
    'all',
    [
      'within',
      {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Polygon',
          coordinates: culturalCentreBounds
        }
      }
    ],
    ['any', ['==', ['get', 'railway'], 'station']]
  ],
  source: 'protomaps',
  'source-layer': 'pois',
  type: 'symbol',
  layout: {
    'text-anchor': 'center',
    'text-field': ['concat', ['get', 'name'], ' ', ['get', 'railway']],
    'text-font': ['Flama Book'],
    'text-letter-spacing': 0.02,
    'text-line-height': 1.1,
    'text-max-width': 8,
    'text-overlap': 'never',
    'text-size': 14
  },
  paint: {
    'text-color': '#797979',
    'text-halo-color': 'white',
    'text-halo-width': 2
  },
  minzoom: 16
};

export const transitBuildingLabels = {
  id: 'transitBuildingLabels',
  filter: [
    'all',
    [
      'in',
      ['get', 'name'],
      ['literal', ['Cultural Centre Platform 1', 'Cultural Centre Platform 2']]
    ]
  ],
  source: 'protomaps',
  'source-layer': 'buildings',
  type: 'symbol',
  layout: {
    'text-anchor': 'center',
    'text-field': ['get', 'name'],
    'text-font': ['Flama Book'],
    'text-letter-spacing': 0.02,
    'text-line-height': 1.1,
    'text-max-width': 8,
    'text-overlap': 'never',
    'text-size': 14
  },
  paint: {
    'text-color': '#797979',
    'text-halo-color': 'white',
    'text-halo-width': 2
  },
  minzoom: 16
};

export const qagomaInterBuildingPathway = {
  id: `qagomaInterBuildingPathway`,
  filter: ['all', ['==', ['get', 'type'], 'interBuildingPathway']],
  type: 'line',
  source: 'qagoma',
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  },
  paint: {
    'line-pattern': 'circle',
    'line-color': 'red',
    'line-width': 4,
    'line-opacity': [
      'interpolate',
      ['exponential', 10],
      ['zoom'],
      16.9,
      ['case', ['==', ['get', 'detail'], 'low'], 1, 0],
      17,
      ['case', ['==', ['get', 'detail'], 'high'], 1, 0]
    ]
  }
};

export const qagomaInterBuildingPathwayTarget = {
  id: `qagomaInterBuildingPathwayTarget`,
  filter: ['all', ['==', ['get', 'type'], 'interBuildingPathway']],
  type: 'line',
  source: 'qagoma',
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  },
  paint: {
    'line-width': 20,
    'line-opacity': 0
  }
};

export const qagomaBase = {
  id: `qagomaBase`,
  filter: ['==', ['get', 'type'], 'building'],
  type: 'fill',
  source: 'qagoma',
  paint: {
    'fill-color': '#d8d9df'
  }
};

export const qagomaBasePattern = {
  id: `qagomaBasePattern`,
  filter: ['==', ['get', 'type'], 'building'],
  type: 'fill',
  source: 'qagoma',
  paint: {
    'fill-pattern': 'pattern-diagonalLine'
  }
};

export const qagomaBaseBorder = {
  id: `qagomaBaseBorder`,
  filter: ['==', ['get', 'type'], 'building'],
  type: 'line',
  source: 'qagoma',
  paint: {
    'line-color': variables['map-primary'],
    'line-width': interpolateWidth(5),
    'line-offset': interpolateWidth(-5 / 2)
  }
};

export const qagomaLevel = {
  id: `qagomaLevel`,
  filter: levelFilter([
    'all',
    ['==', ['get', 'type'], 'level'],
    ['var', 'isActiveLevel']
  ]),
  type: 'fill',
  source: 'qagoma',
  paint: {
    'fill-color': variables['map-fill']
  }
};

export const qagomaGrass = {
  id: `qagomaGrass`,
  filter: levelFilter([
    'all',
    ['==', ['coalesce', ['get', 'terrain'], ['get', 'type']], 'grass'],
    ['var', 'isActiveLevel']
  ]),
  type: 'fill',
  source: 'qagoma',
  paint: {
    'fill-pattern': 'pattern-grass',
    'fill-opacity': ['interpolate', ['exponential', 2], ['zoom'], 17, 0, 18, 1]
  }
};

export const qagomaGrassFill = {
  id: `qagomaGrassFill`,
  filter: levelFilter([
    'all',
    ['==', ['coalesce', ['get', 'terrain'], ['get', 'type']], 'grass'],
    ['var', 'isActiveLevel']
  ]),
  type: 'fill',
  source: 'qagoma',
  paint: {
    'fill-color': variables['map-terrain'],
    'fill-opacity': [
      'interpolate',
      ['exponential', 2],
      ['zoom'],
      15,
      0,
      18,
      0.25
    ]
  }
};

export const qagomaWater = {
  id: `qagomaWater`,
  filter: levelFilter([
    'all',
    ['==', ['get', 'type'], 'water'],
    ['var', 'isActiveLevel']
  ]),
  type: 'fill',
  source: 'qagoma',
  paint: {
    'fill-color': variables['map-water']
  }
};

export const qagomaInaccessible = {
  id: `qagomaInaccessible`,
  filter: levelFilter([
    'all',
    ['var', 'isActiveLevel'],
    [
      'any',
      ['==', ['get', 'type'], 'inaccessibleAreas'],
      [
        'all',
        closedVenueFilter,
        [
          'in',
          ['get', 'type'],
          [
            'literal',
            ['gallery_space', 'internal_venue', 'internal_venue_fill']
          ]
        ],
        ['!=', ['coalesce', ['get', 'hidden'], false], true]
      ]
    ]
  ]),
  type: 'fill',
  source: 'qagoma',
  paint: {
    'fill-color': variables['map-primary'],
    'fill-opacity': 0.25
  }
};

export const qagomaInaccessiblePattern = {
  id: `qagomaInaccessiblePattern`,
  filter: qagomaInaccessible.filter,
  type: 'fill',
  source: 'qagoma',
  paint: {
    'fill-pattern': 'pattern-diagonalDash'
  }
};

export const qagomaSpaces = {
  id: `qagomaSpaces`,
  filter: levelFilter([
    'all',
    openVenueFilter,
    [
      'in',
      ['get', 'type'],
      ['literal', ['gallery_space', 'internal_venue', 'internal_venue_fill']]
    ],
    [
      'any',
      ['boolean', ['var', 'isActiveLevel']],
      ['coalesce', ['get', 'ignoreVisibility'], false]
    ],
    ['!', ['in', ['geometry-type'], ['literal', ['Point', 'MultiPoint']]]]
  ]),
  type: 'fill',
  source: 'qagoma',
  paint: {
    'fill-color': [
      'case',
      ['any', ['==', ['get', 'hidden'], true], ['has', 'terrain']],
      ['rgba', 0, 0, 0, 0],
      ['==', ['feature-state', 'isSelectable'], false],
      'rgb(213, 218, 223)',
      ['==', ['get', 'type'], 'gallery_space'],
      variables['map-gallery'],
      variables['map-venue']
    ],
    'fill-opacity': [
      'case',
      ['==', ['feature-state', 'selected'], true],
      1,
      ['==', ['feature-state', 'isSelectable'], false],
      0.3,
      0.15
    ]
  },
  minzoom: 16
};

export const qagomaEntrances = {
  id: `qagomaEntrances`,
  filter: levelFilter([
    'all',
    ['==', ['get', 'type'], 'entrance'],
    ['var', 'isActiveLevel']
  ]),
  type: 'line',
  source: 'qagoma',
  paint: {
    'line-color': variables['map-fill'],
    'line-width': interpolateWidth(10),
    'line-offset': interpolateWidth([
      'case',
      [
        'all',
        ['==', ['get', 'building'], 'goma'],
        ['==', ['get', 'level'], 'level_1']
      ],
      118,
      0
    ])
  }
};

export const qagomaInternalWalls = {
  id: `qagomaInternalWalls`,
  filter: levelFilter([
    'all',
    openVenueFilter,
    [
      'in',
      ['get', 'type'],
      ['literal', ['internalWalls', 'inaccessibleAreas', 'water']]
    ],
    ['var', 'isActiveLevel']
  ]),
  type: 'line',
  source: 'qagoma',
  paint: {
    'line-color': variables['map-primary'],
    'line-width': interpolateWidth(2.5)
  }
};

export const qagomaLevelBorder = {
  id: `qagomaLevelBorder`,
  filter: levelFilter([
    'all',
    [
      'any',
      ['==', ['get', 'type'], 'level_outline'],
      [
        'all',
        ['==', ['get', 'type'], 'level'],
        ['!=', ['get', 'outline'], false]
      ]
    ],
    ['var', 'isActiveLevel']
  ]),
  type: 'line',
  source: 'qagoma',
  paint: {
    'line-color': variables['map-primary'],
    'line-width': interpolateWidth(10)
  }
};

export const qagomaTraversalBase = {
  id: `qagomaTraversalBase`,
  filter: levelFilter([
    'all',
    openVenueFilter,
    ['==', ['get', 'type'], 'traversal'],
    ['var', 'isActiveLevel']
  ]),
  type: 'fill',
  source: 'qagoma',
  paint: {
    'fill-color': variables['map-fill']
  }
};

export const qagomaTraversal = {
  id: `qagomaTraversal`,
  filter: levelFilter([
    'all',
    openVenueFilter,
    ['==', ['get', 'type'], 'traversal'],
    ['var', 'isActiveLevel']
  ]),
  type: 'line',
  source: 'qagoma',
  paint: {
    'line-color': variables['map-primary'],
    'line-width': interpolateWidth(2.5)
  }
};

export const qagomaAmenities = {
  id: `qagomaAmenities`,
  filter: levelFilter([
    'all',
    openVenueFilter,
    ['has', 'amenity'],
    ['var', 'isActiveLevel']
  ]),
  type: 'symbol',
  source: 'qagoma',
  layout: {
    'icon-image': ['image', ['get', 'amenity']],
    'icon-size': [
      'interpolate',
      ['exponential', 2],
      ['zoom'],
      17,
      0.5,
      20,
      1.25
    ],
    'icon-overlap': 'cooperative'
  },
  minzoom: 16
};

export const qagomaTraversalIcon = {
  id: `qagomaTraversalIcon`,
  filter: levelFilter([
    'all',
    openVenueFilter,
    ['has', 'traversal'],
    ['var', 'isActiveLevel']
  ]),
  type: 'symbol',
  source: 'qagoma',
  layout: {
    'icon-image': ['image', ['get', 'traversal']],
    'icon-size': [
      'interpolate',
      ['exponential', 2],
      ['zoom'],
      17,
      0.5,
      20,
      1.25
    ],
    'icon-overlap': 'cooperative'
  },
  minzoom: 16
};

export const qagomaSpacesLabel = {
  id: `qagomaSpacesLabel`,
  filter: levelFilter([
    'all',
    openVenueFilter,
    [
      'in',
      ['get', 'type'],
      ['literal', ['gallery_space', 'internal_venue', 'internal_venue_label']]
    ],
    ['!', ['has', 'markerLabel']],
    [
      'any',
      [
        'all',
        ['var', 'isActiveLevel'],
        ['!=', ['get', 'inverseVisibility'], true]
      ],
      [
        'all',
        ['==', ['get', 'inverseVisibility'], true],
        ['!', ['var', 'isActiveLevel']]
      ]
    ]
  ]),
  type: 'symbol',
  source: 'qagoma',
  layout: {
    'icon-image': [
      'case',
      ['has', 'venue'],
      ['get', 'type', ['get', 'venue']],
      ''
    ],
    'icon-size': [
      'interpolate',
      ['exponential', 2],
      ['zoom'],
      16.5,
      0.5,
      20,
      1.25
    ],
    'icon-anchor': ['step', ['zoom'], 'center', 18, 'bottom'],
    'icon-offset': [0, -5],
    'text-field': ['step', ['zoom'], '', 18, ['get', 'name']],
    'text-font': ['Flama Medium'],
    'text-justify': 'auto',
    'text-letter-spacing': 0.05,
    'text-line-height': 0.9,
    'text-max-width': 8,
    'text-optional': true,
    'text-size': ['interpolate', ['exponential', 2], ['zoom'], 16, 9, 20, 28],
    'text-anchor': 'top'
  },
  paint: {
    'text-color': variables['map-primary'],
    'text-halo-color': variables['map-fill'],
    'text-halo-width': [
      'interpolate',
      ['exponential', 2],
      ['zoom'],
      16.5,
      ['case', ['has', 'terrain'], 2, 1],
      20,
      ['case', ['has', 'terrain'], 5, 3]
    ]
  },
  minzoom: 16.5
};

export const qagomaSpacesMarker = {
  id: `qagomaSpacesMarker`,
  filter: levelFilter([
    'all',
    ['in', ['get', 'type'], ['literal', ['gallery_space', 'internal_venue']]],
    ['has', 'markerLabel'],
    ['var', 'isActiveLevel']
  ]),
  type: 'symbol',
  source: 'qagoma',
  layout: {
    'icon-image': 'marker',
    'icon-size': [
      'interpolate',
      ['exponential', 2],
      ['zoom'],
      16,
      0.5,
      20,
      1.5
    ],
    'icon-anchor': 'bottom',
    'icon-allow-overlap': true,
    'icon-overlap': 'always',
    'text-anchor': 'bottom',
    'text-field': ['get', 'markerLabel'],
    'text-font': ['Flama Medium'],
    'text-letter-spacing': 0.07,
    'text-line-height': 1.1,
    'text-max-width': 8,
    'text-offset': [0, -1.25],
    'text-overlap': 'never',
    'text-size': ['interpolate', ['exponential', 2], ['zoom'], 16, 9, 20, 28]
  },
  paint: {
    'text-color': variables['map-fill'],
    'text-halo-color': variables['map-primary'],
    'text-halo-width': [
      'interpolate',
      ['exponential', 2],
      ['zoom'],
      16.5,
      ['case', ['has', 'terrain'], 2, 1],
      20,
      ['case', ['has', 'terrain'], 5, 3]
    ]
  },
  minzoom: 16
};

export const qagomaEntranceLabels = {
  id: `qagomaEntranceLabels`,
  filter: levelFilter([
    'all',
    ['==', ['get', 'type'], 'entranceLabel'],
    ['var', 'isActiveLevel']
  ]),
  type: 'symbol',
  source: 'qagoma',
  layout: {
    'symbol-placement': 'line-center',
    'icon-allow-overlap': true,
    'icon-anchor': 'top',
    'icon-image': 'arrow',
    'icon-offset': [0, 2],
    'icon-overlap': 'always',
    'icon-rotation-alignment': 'map',
    'icon-size': ['interpolate', ['exponential', 2], ['zoom'], 16, 0.4, 20, 1],
    'text-allow-overlap': true,
    'text-anchor': 'center',
    'text-field': 'Entrance',
    'text-font': ['Flama Medium'],
    'text-keep-upright': true,
    'text-letter-spacing': 0.07,
    'text-line-height': 1.1,
    'text-max-width': 20,
    'text-offset': [0, 2.25],
    'text-overlap': 'always',
    'text-padding': 20,
    'text-rotation-alignment': 'map',
    'text-size': ['interpolate', ['exponential', 2], ['zoom'], 16, 11, 20, 28]
  },
  paint: {
    'text-color': variables['map-outline'],
    'text-halo-color': variables['map-fill'],
    'text-halo-width': [
      'interpolate',
      ['exponential', 2],
      ['zoom'],
      16,
      1,
      20,
      3
    ]
  },
  minzoom: 16
};

export const qagomaBaseCover = {
  id: `qagomaBaseCover`,
  filter: ['==', ['get', 'type'], 'building'],
  type: 'fill',
  source: 'qagoma',
  paint: {
    'fill-color': variables['map-primary'],
    'fill-opacity': [
      'interpolate',
      ['exponential', 0.5],
      ['zoom'],
      16,
      1,
      17,
      0
    ]
  },
  maxzoom: 17
};

export const qagomaBaseCoverBorder = {
  id: `qagomaBaseCoverBorder`,
  filter: ['==', ['get', 'type'], 'building'],
  type: 'line',
  source: 'qagoma',
  paint: {
    'line-color': variables['map-outline'],
    'line-width': 2,
    'line-opacity': [
      'interpolate',
      ['exponential', 0.5],
      ['zoom'],
      16,
      1,
      17,
      0
    ]
  },
  maxzoom: 17
};

export const qagomaInterBuildingPathwayPoints = {
  id: `qagomaInterBuildingPathwayPoints`,
  filter: ['all', ['==', ['get', 'type'], 'interBuildingPathwayPoint']],
  type: 'symbol',
  source: 'qagoma',
  layout: {
    'icon-anchor': 'top',
    'icon-image': 'entrance-arrow',
    'icon-offset': [0, -5],
    'icon-padding': 0,
    'icon-rotation-alignment': 'map',
    'icon-size': 0.5,
    'symbol-placement': 'line-center'
  },
  maxzoom: 17
};

export const qagomaBuildingLabels = {
  id: `qagomaBuildingLabels`,
  filter: ['all', ['==', ['get', 'type'], 'buildingLabel']],
  type: 'symbol',
  source: 'qagoma',
  layout: {
    'symbol-sort-key': -1,
    'symbol-avoid-edges': true,
    'text-justify': 'center',
    'text-anchor': 'center',
    'text-field': ['get', 'name'],
    'text-font': ['Flama Medium'],
    'text-letter-spacing': 0.07,
    'text-line-height': 1.1,
    'text-max-width': 8,
    'text-overlap': 'always',
    'text-allow-overlap': true,
    'text-radial-offset': 10,
    'text-size': [
      'interpolate',
      ['exponential', 1.16],
      ['zoom'],
      0,
      18,
      15,
      18,
      22,
      16
    ]
  },
  paint: {
    'text-opacity': [
      'interpolate',
      ['exponential', 0.5],
      ['zoom'],
      14,
      1,
      16,
      1,
      17,
      0
    ],
    'text-color': variables['map-fill'],
    'text-halo-color': variables['map-primary'],
    'text-halo-width': 1.5,
    'text-halo-blur': 0
  },
  maxzoom: 17
};
